// Utility function to parse markdown-style bold text
export const parseMarkdown = (text) => {
  if (!text) return text;
  const parts = text.split(/(\*\*.*?\*\*)/g);
  return parts.map((part, index) => {
    if (part.startsWith("**") && part.endsWith("**")) {
      return <strong key={index}>{part.slice(2, -2)}</strong>;
    }
    return part;
  });
};


export const getCourseDetails = (courseData) => {
  if (!courseData?.CourseDetails) {
    return [];
  }
  return courseData.CourseDetails.split("\n")
    .filter((line) => line.trim().startsWith("-"))
    .map((line) => line.trim().substring(1).trim());
};

// Handle PDF download
export const handleDownloadBrochure = (course) => {
  const pdfUrl = course?.BrochurePdf?.url;
  if (pdfUrl) {
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = course.BrochurePdf.name || "brochure.pdf";
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    alert("Brochure is not available for download.");
  }
};



  export const resolveUrl = (u) => {
    if (!u) return null;
    if (/^https?:\/\//i.test(u)) return u;
    const base = (process.env.NEXT_PUBLIC_SERVER_URL || "").replace(/\/$/, "");
    if (!base) return u;
    if (u.startsWith("/")) return `${base}${u}`;
    return `${base}/${u}`;
  };


export const isYouTube = (u) => /(?:youtube\.com|youtu\.be)/i.test(u);
  // const isVideoExt = (u) => /\.(mp4|webm|ogg|mov)(?:\?|$)/i.test(u) || isYouTube(u);
export const isImageExt = (u) => /\.(png|jpe?g|webp|gif|svg)(?:\?|$)/i.test(u);


  // If no poster provided and media is YouTube, compute YouTube thumbnail as fallback
  // Robust YouTube ID extractor that handles multiple URL forms (watch?v=, embed/, youtu.be/, shorts/)
export const getYouTubeId = (u) => {
    if (!u) return null;
    try {
      const url = new URL(u);
      const host = url.hostname.replace(/^www\./i, "").toLowerCase();

      // short url: youtu.be/ID
      if (host === "youtu.be") {
        const id = url.pathname.split("/").filter(Boolean)[0];
        return id || null;
      }

      // youtube domains
      if (host === "youtube.com" || host.endsWith(".youtube.com") || host === "m.youtube.com") {
        // v= param
        const v = url.searchParams.get("v");
        if (v) return v;
        // path based IDs: /embed/ID or /shorts/ID
        const parts = url.pathname.split("/").filter(Boolean);
        if (parts[0] === "embed" || parts[0] === "shorts") return parts[1] || null;
        return null;
      }

      // fallback regex for anything else
      const m = u.match(/(?:v=|\/embed\/|\.be\/|\/shorts\/)([^&?\/]+)/i);
      return m ? m[1] : null;
    } catch (e) {
      const m = u.match(/(?:v=|\/embed\/|\.be\/|\/shorts\/)([^&?\/]+)/i);
      return m ? m[1] : null;
    }
  };


export const PlayIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
        <path d="M8 5v14l11-7z" />
    </svg>
);



export const youtubeId = (u) => {
        if (!u) return null;
        const ytMatch = u.match(/(?:v=|\/)([\w-]{11})(?:\?|&|$)/) || u.match(/youtu\.be\/([\w-]{11})/);
        return ytMatch ? ytMatch[1] : null;
    };
export const getYouTubeEmbed = (u) => {
        const id = youtubeId(u);
        return id ? `https://www.youtube.com/embed/${id}?autoplay=1&rel=0` : null;
    };
export const getYouTubeThumb = (u) => {
        const id = youtubeId(u);
        return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : null;
    };



export // ✅ Move outside (no re-creation)
const ArrowIcon = () => (
  <svg
    className="text-white ml-2 opacity-0 -translate-x-2 translate-y-2 group-hover:opacity-100 group-hover:translate-x-0 group-hover:translate-y-0 transition-all duration-300"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M7 17L17 7M17 7H7M17 7V17" />
  </svg>
);

export const ContentOverlay = ({ title }) => (
  <div className="absolute inset-0 flex flex-col pointer-events-none">
    <div className="relative z-10 p-5 md:p-6 mt-auto transition-transform duration-300 group-hover:-translate-y-2">
      <div className="flex items-center justify-between">
        <span className="text-white font-semibold text-[20px]">
          {title}
        </span>
        <ArrowIcon />
      </div>
    </div>
  </div>
);
